<div class="modal-header">
    <h4 class="modal-title">Child Health (0-5 years)</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="card-body" [formGroup]="childForm">
        <div class="row">
            <!-- Immunization Given (Multi-select) -->
            <div class="col-xl-3 mb-2">
                <label>Immunization Given</label>
                <select   class="form-control form-control-sm" formControlName="immune_given_id" (click)="isOtherSelected($event.target.value)">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of imztnList" [value]="opt.id">{{ opt.name }}</option>

                </select>
             
            </div>
            <div class="col-xl-3 mb-2" *ngIf="enableOtherimmune">
                <label>Other Immunization Given</label>
                <input class="form-control form-control-sm" formControlName="if_others_immune_given"
                    placeholder="Enter other immunization">
            </div>

            <!-- Nutrition Status -->
            <div class="col-xl-3 mb-2">
                <label>Nutrition Status</label>
                <select class="form-control form-control-sm" formControlName="nutrition_status_id">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of nutritianList" [value]="opt.id">{{ opt.name }}</option>
                </select>
            </div>

            <!-- Common Illness (Multi-select) -->
            <div class="col-xl-3 mb-2">
                <label>Common Illness</label>
                <select  class="form-control form-control-sm" formControlName="common_illness_id" (click)="isOtherSelectedIllness($event.target.value)">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of illnessList" [value]="opt.id">{{ opt.name }}</option>
                </select>

            </div>
                    <div class="col-xl-3 mb-2" *ngIf="enableOtherIllness">
                <label>Other Common Illness</label>
                <input class="form-control form-control-sm" formControlName="if_others_common_illness"  
                    placeholder="Enter other illness">
            </div>

            <!-- Treatment Given (Multi-select) -->
            <div class="col-xl-3 mb-2">
                <label>Treatment Given</label>
                <select  class="form-control form-control-sm" formControlName="treatment_given_id" (click)="isOtherSelectedTreatment($event.target.value)">
                    <option value=null>Select</option>
                     <option *ngFor="let opt of treatmentList" [value]="opt.id">{{ opt.name }}</option>

                </select>
            </div>
                                <div class="col-xl-3 mb-2" *ngIf="enableTreatment">
                <label>Other Treatment Given</label>
                <input class="form-control form-control-sm" formControlName="if_others_treatment_given"
                    placeholder="Enter other treatment">
            </div>


            <!-- <div class="col-xl-3 mb-2">
                <label>Referred To</label>
                <select class="form-control form-control-sm" formControlName="consult_refer_to_id">
                  <option value=null>Select</option>
                   <option *ngFor="let opt of referredist" [value]="opt.id">{{ opt.name }}</option>

                </select>
            </div>  -->

        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" id="saveButton" class="btn btn-primary btn-sm" (click)="onSave()">Save</button>

    <button type="button" id="closeButton" class="btn btn-outline-dark btn-sm"
        (click)="activeModal.close('Close click')">Close</button>
</div>